/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Frame_Back_TitleInputs */

const en_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame Back`)
};

const fr_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Precedente`)
};

const de_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rahmenrückseite`)
};

const it_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telaio posteriore`)
};

const ru_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рамка сзади`)
};

const es_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco trasero`)
};

const zh_cn2_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`框架背面`)
};

const ja_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームバック`)
};

const hi_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम का पिछला भाग`)
};

const pt_pt2_player_frame_back_title = /** @type {(inputs: Player_Frame_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte traseira da moldura`)
};

/**
* | output |
* | --- |
* | "Frame Back" |
*
* @param {Player_Frame_Back_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_frame_back_title = /** @type {((inputs?: Player_Frame_Back_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Frame_Back_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_frame_back_title(inputs)
	if (locale === "de") return de_player_frame_back_title(inputs)
	if (locale === "it") return it_player_frame_back_title(inputs)
	if (locale === "ru") return ru_player_frame_back_title(inputs)
	if (locale === "es") return es_player_frame_back_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_frame_back_title(inputs)
	if (locale === "ja") return ja_player_frame_back_title(inputs)
	if (locale === "hi") return hi_player_frame_back_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_frame_back_title(inputs)
	return en_player_frame_back_title(inputs)
});